<div class="d-flex flex-column" style="gap:10px">
    <button mat-flat-button class="btn-action btn-with-icon" color="accent" (click)="addParam()"><img
            style="width:25px;" src="/assets/img/add-rekbot.png" alt=""> Dodaj parametr</button>
    <table mat-table [dataSource]="dataSource" matSort class="common-table">

        <!-- name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>

        <!-- val Column -->
        <ng-container matColumnDef="val">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Wartość</th>
            <td mat-cell *matCellDef="let element" style="max-width: 500px;">
                <div class="overflow-auto">
                    {{element.val}}
                </div>
            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td class="action-cell" mat-cell *matCellDef="let element">
                <div class="action-cell">
                    <button type="button" class="btn btn-primary btn-action" (click)="edit(element)"
                        matTooltip="Edytuj"><mat-icon aria-hidden="false" aria-label="Edytuj"
                            fontIcon="edit"></mat-icon></button>
                    <button type="button" class="btn btn-danger btn-action" (click)="remove(element)"
                        matTooltip="Usuń"><mat-icon aria-hidden="false" aria-label="Usuń">delete</mat-icon></button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>